import React from 'react'
// containers
import BusinessProcessesContainer from 'containers/BusinessProcesses'

const BusinessProcessesSettingsPage: React.FC = () => <BusinessProcessesContainer />

export default BusinessProcessesSettingsPage

